import React from "react";
import FeedStory from "../feedStory/feedStory";
import { useRssFetch } from "../../custom-hooks/useRssFetch";
import LoadSpinner from "../loadSpinner/LoadSpinner";
import type { FeedItem, Story } from "../../types/rss";

export interface WapoFeedProps {
  /** Path segment identifying which feed to load. */
  urlStub: string;
}

const WapoFeed = (props: WapoFeedProps) => {
  const urlStub = props.urlStub.slice(5, props.urlStub.length);
  const feed = useRssFetch(`http://feeds.washingtonpost.com/rss/${urlStub}`);

  if (!feed || !feed.items) {
    return <LoadSpinner />;
  }
  const stories: Story[] = [];
  feed.items.forEach(function (entry: FeedItem) {
    const media = entry.media ? entry.media[0] : null;
    const mediaContent =
      media && media["media:content"] ? media["media:content"][1] : null;
    stories.push({
      name: entry.title ?? "",
      url: entry.link ?? "",
      author: entry.creator,
      img: mediaContent?.$?.url ?? ""
    });
  });

  return (
    <div className="rssFeed">
      {stories.map((story, i) => {
        return (
          <FeedStory
            key={i}
            story={story}
            shouldShowImage={i === 0 && story.img !== ""}
          />
        );
      })}
    </div>
  );
};

export default React.memo(WapoFeed);
